import { Col, Image, Row } from "react-bootstrap"


export const SeasonImage = () => {



    return (
        <Row className="justify-content-center align-items-center mt-2 mb-2">
            <Col lg="6">
                <Image src="https://leningradcenter.ru/uploadfiles/638896475290788298_Otpusk_1920x1080.jpg" fluid />
            </Col>
        </Row>
    )
}